import { render, staticRenderFns } from "./InputPercent.vue?vue&type=template&id=fba97cca&scoped=true&"
import script from "./InputPercent.vue?vue&type=script&lang=js&"
export * from "./InputPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba97cca",
  null
  
)

export default component.exports